import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="min-h-screen bg-gray-50 px-6 py-20 text-center text-gray-900">
      <h1 className="text-3xl font-bold">Page not found</h1>
      <p className="mt-4">This calculator or page does not exist at this address.</p>
      <Link className="mt-6 inline-block text-blue-700 underline" to="/calculators">Browse all calculators</Link>
    </main>
  );
}
